import { createReducer, on } from '@ngrx/store';
import * as OrderBumpActions from './order-bump.actions';

export const initialState: number[] = [];

export const ORDERBUMP_FEATURE_KEY = 'orderbump_products';

export const orderBumpReducer = createReducer(
  initialState,
  on(OrderBumpActions.orderBumpAddProduct, (state, { product_id }) => {
    return [...state, +product_id];
  }),
  on(OrderBumpActions.orderBumpRemoveProduct, (state, { product_id }) => {
    return state.filter((id) => id !== product_id);
  })
);
